var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',_vm._l((_vm.items),function(item,ind){return _c('Drag',{key:ind,on:{"drag-start":function($event){return _vm.dragStart($event, ind)},"dragging":_vm.dragging,"drag-stop":_vm.dragStop}},[_c('span',{ref:"draggingItem",refInFor:true},[_vm._t("items",null,{"item":item})],2)])}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }